<style lang="scss" scoped type="text/scss">

  .btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
  }

  .btn-primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
  }

  .btn-warning {
    color: #fff;
    background-color: #f6a742;
    border-color: #f6a742;
  }

</style>
<template>
  <button
    class="btn"
    :class="[type?'btn-'+type:'']"
    @click="handleClick"
    :autofocus="autofocus"
    type="button">
    <span>
      <slot></slot>
    </span>
  </button>
</template>

<script>
  export default {
    componentName: 'Button',

    props: {
      autofocus: String,
      type: {
        type: String,
        default: 'default'
      },
      size: String,
      value: {
        type: String
      }
    },
    methods: {
      handleClick(evt) {
        this.$emit('click', evt);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Button/Button.vue